/* Spawners for the workers that are started from OUTSIDE this package.
 *
 * `new URL('./x.worker.ts', import.meta.url)` is resolved by the bundler
 * against the file it is written in, and it is not an import specifier — so it
 * survives no amount of rewriting when the worker moves to another package. It
 * has to be written next to the worker. The app used to spawn these two
 * directly and the build broke the moment the workers moved; the URL is the
 * package's business, so the package hands out the Worker.
 *
 * The other two workers here — sounding and terrain — are not in this file
 * because nothing outside ever spawns them: their protocol handlers
 * (`sounding-protocol.ts`, `terrain-protocol.ts`) own their lifecycle and
 * already construct them in place. Same rule, satisfied differently.
 *
 * `{ type: 'module' }` is not optional. These are ES modules; a classic worker
 * would fail on the first `import` with a syntax error that does not name the
 * cause.
 */

/** The autorouter's A* solve. See `router.worker.ts` for the protocol. */
export const spawnRouterWorker = (): Worker =>
  new Worker(new URL('./router.worker.ts', import.meta.url), { type: 'module' });

/** The wind-field IDW solve, masked by the costgrid. See `windfield.worker.ts`. */
export const spawnWindFieldWorker = (): Worker =>
  new Worker(new URL('./windfield.worker.ts', import.meta.url), { type: 'module' });
